import { render } from "./OurStory.vue?vue&type=template&id=337eb381&scoped=true&ts=true"
import script from "./OurStory.vue?vue&type=script&lang=ts"
export * from "./OurStory.vue?vue&type=script&lang=ts"

import "./OurStory.vue?vue&type=style&index=0&id=337eb381&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337eb381"]])

export default __exports__